import { getCurrentSessionWorkoutName } from "./cycle-helpers";

/**
 * Resolve plan training card content for a day's exercises.
 * @returns {{ variant: "rest" | "custom" | "cycle", programName?: string, blockName?: string, workoutName?: string, programSession?: number, programWeek?: number }}
 */
export function getPlanTrainingCardContent(exercises, cycles = []) {
  if (!exercises?.length) {
    return { variant: "rest" };
  }

  const exercise = exercises.find((e) => e.cycle) || exercises[0];

  if (!exercise.cycle) {
    return { variant: "custom" };
  }

  const cycleDetail = exercise.cycle;
  const cycleDoc = cycles.find((c) => String(c._id) === String(cycleDetail.id));

  if (!cycleDoc) {
    return { variant: "custom" };
  }

  const program = cycleDoc.programs?.find(
    (p) => Number(p.order) === Number(cycleDetail.program)
  );

  const workoutName =
    program?.sessions &&
    Array.isArray(program.sessions) &&
    program.sessions.length > 0 &&
    cycleDetail.programSession &&
    cycleDetail.programWeek
      ? getCurrentSessionWorkoutName(
          program.sessions,
          cycleDetail.programWeek,
          cycleDetail.programSession
        )
      : undefined;

  const storeType = cycleDoc.storeType || "programs";

  if (!cycleDoc.name && !workoutName && storeType !== "programs") {
    return { variant: "custom" };
  }

  return {
    variant: "cycle",
    programName: cycleDoc.name,
    blockName: program?.name,
    workoutName,
    programSession: cycleDetail.programSession,
    programWeek: cycleDetail.programWeek,
  };
}
